import React from 'react'

const toAsset = (fileName) => {
	return require(`assets/${fileName}`).default
}

export const Image = ({ fileName, ...props }) => <img src={toAsset(fileName)} {...props} alt='icon' />